module.exports = __webpack_public_path__ + "img/logo-clean.8aad347f.jpg";